import { EVENT_TYPE } from '@hedepy/common/enums/EVENT_TYPE'
import { SERVICE_TYPE } from '@hedepy/common/enums/SERVICE_TYPE'
import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'
import dynamic from 'next/dynamic'

import useToggleState from '@/legacy-src/hooks/useToggleState'
import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { ClientBookingSelectAction } from '@/src/domains/client-booking/components/ClientBookingAvailableSlots/ClientBookingAvailableSlot/ClientBookingAvailableSlot.constants'
import { ClientBookingAvailableSlotTimeSlot } from '@/src/domains/client-booking/components/ClientBookingAvailableSlots/ClientBookingAvailableSlot/ClientBookingAvailableSlotTimeSlot'
import { useIsClientOfflineBookingAvailable } from '@/src/domains/client-booking/hooks/useIsClientOfflineBookingAvailable'

const ClientBookingAvailableSlotConfirmationDialog = dynamic(
  () =>
    import('./ClientBookingAvailableSlotConfirmationDialog').then(
      (mod) => mod.ClientBookingAvailableSlotConfirmationDialog,
    ),
  { ssr: false },
)

export interface ClientBookingAvailableSlotConfirmationProps {
  therapist: TherapistType
  slot: FreeSlot
  service: ServiceType
  isSelected: boolean
  onSelect: (type: EVENT_TYPE, action: ClientBookingSelectAction) => void
  onDeselect: () => void
}

export const ClientBookingAvailableSlotConfirmation = ({
  therapist,
  slot,
  service,
  isSelected,
  onSelect,
  onDeselect,
}: ClientBookingAvailableSlotConfirmationProps) => {
  const [open, toggle] = useToggleState()

  const isTherapistOfflineAvailable = useIsClientOfflineBookingAvailable({ therapist })
  const isOfflineAvailable = service.type !== SERVICE_TYPE.FREE_DEMO && isTherapistOfflineAvailable

  return (
    <>
      <ClientBookingAvailableSlotTimeSlot
        slot={slot}
        selected={isSelected}
        onClick={() => {
          if (isSelected) {
            onDeselect()
          } else if (isOfflineAvailable) {
            toggle()
          } else {
            onSelect(EVENT_TYPE.ONLINE, ClientBookingSelectAction.PROCEED)
          }
        }}
        data-test-is-available
      />
      {open ? (
        <ClientBookingAvailableSlotConfirmationDialog
          therapist={therapist}
          open={open}
          onOpenChange={toggle}
          slot={slot}
          onSelect={(...args) => {
            onSelect(...args)
            toggle()
          }}
        />
      ) : null}
    </>
  )
}
